/**
 * External dependencies:
 */
import React from "react";
import { createRoot } from "react-dom/client";

import { showToastMessage } from "./modules/add-to-cart";
import Cart from "@/frontend/domain/cart/pages/cart";

const root = document.querySelector(".cart-app");

if (root.dataset.error) {
    showToastMessage(10_000, root.dataset.error);
}

createRoot(root).render(<Cart />);
